import { InvoiceRepetitionOptions, ReferenceMethods } from '@root/constants'
import { IInvoice } from '@root/query'

export const isEligibleForPostDueAutomation = (invoice: Partial<IInvoice>) => {
  return !(
    invoice?.recurrence_rule?.rule?.frequency !== InvoiceRepetitionOptions.NO_SELECTION &&
    invoice?.recurrence_reference_method === ReferenceMethods.keep
  )
}
